module.exports = __webpack_public_path__ + "static/media/card.198f5eef.svg";